import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '@assetaccountant/core';
import { OfferInstance } from '@assetaccountant/core/models/offers/offer-instance';
import { AzureMarketPlaceService } from '@assetaccountant/core/services/azure-market-place.service';

@Component({
  selector: 'app-azure-market-place',
  templateUrl: './azure-market-place.component.html',
  styleUrls: ['./azure-market-place.component.scss'],
  standalone: false,
})
export class AzureMarketPlaceComponent implements OnInit {
  private offerInstance: OfferInstance;
  private token: string | null;
  private missingToken: boolean;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthenticationService,
    private azMarketPlaceService: AzureMarketPlaceService,
  ) {
    this.missingToken = false;
  }

  get title() {
    return {
      pageTitle: 'Setup FinQuery Fixed Assets via Azure Market Place',
      pageHeading: [{ name: 'Setup FinQuery Fixed Assets via Azure Market Place' }],
    };
  }
  private getAppRoot(): string {
    return `${location.protocol}//${location.host}`;
  }

  get isLoaded() {
    return this.offerInstance != null || this.missingToken;
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');

    if (this.token) {
      this.azMarketPlaceService
        .getOfferFromToken(this.token)
        .subscribe((offerInstance: OfferInstance) => {
          this.offerInstance = offerInstance;
          const offerActionUrl = 'create-organisation-special';
          const provider = 'AzureAD';
          const relativeOfferActionUrl = `/${offerActionUrl}/${this.offerInstance.campaignKey}/${this.offerInstance.couponId}`;
          if (this.offerInstance.isRedeemable.result) {
            if (!this.authService.isAuthenticated()) {
              const fullOfferActionUrl = `${this.getAppRoot()}/${relativeOfferActionUrl}`;
              this.authService.init(fullOfferActionUrl, {
                acr_values: `idp:${provider}`,
              });
              return;
            } else {
              // we must use Azure AD for this to work.
              if (this.authService.getIdentityProvider() !== provider) {
                this.offerInstance.isRedeemable.result = false;
                this.offerInstance.isRedeemable.reason = `The offer is for an Azure Market Place only and not ${this.authService.getIdentityProvider()} you need to sign into Azure AD Account to redeem the offer`;
              }
              if (this.offerInstance.isRedeemable.result) {
                this.router.navigate([relativeOfferActionUrl]);
              }
            }
          } else {
            if (this.authService.isAuthenticated()) {
              // The user as landed on the page and coupon the subscription has
              // already been setup it is likely they are clicking a link from the email
              // so taken them the default page // we might want to test provider as well
              // we can if needed to connect back to the service to check if the SubscriptionId in the
              // token matches the couponId, however this will only work for 24 hours after publish
              this.router.navigate(['/organisations/-/dashboard']);
            } else {
              // offer not Redeemable show message
            }
          }
        });
    } else {
      this.missingToken = true;
    }
  }
  get isRedeemable(): boolean {
    if (!this.missingToken) {
      if (this.offerInstance && this.offerInstance.isRedeemable) {
        return this.offerInstance.isRedeemable.result;
      }
      return true;
    } else {
      return false;
    }
  }
  get isRedeemableMessage(): string {
    if (!this.missingToken) {
      if (this.offerInstance && this.offerInstance.isRedeemable) {
        return this.offerInstance.isRedeemable.reason;
      }
      return '';
    } else {
      return 'Missing Market place Token';
    }
  }
}
